import { ProgramPaywallGeneralDataType } from '@7chairs/types';

import { Plan } from '../../../../types/plan';
import {
  PickProgramSectionContent,
  PickProgramSectionProducts,
  PickProgramSectionMobileRightLightEggBg,
  PickProgramSectionTitle,
  PickProgramSectionWrapper,
} from './PickProgramSection.style';
import { DEFAULT_PLAN_KEY } from '../PickAProgram.types';
import { ProgramV2 } from './ProgramV2';
import rightLightEgg from '../../../../assets/rightLightEgg.webp';

interface PickPlanSectionProps {
  planPositions: string[];
  stripePlans: Record<string, Plan>;
  chosenPlanPosition: string | null;
  pickAProgram: (pp: string, id: string) => void;
  data: ProgramPaywallGeneralDataType;
}

export const PickProgramSection = (props: PickPlanSectionProps) => {
  const { planPositions, stripePlans, chosenPlanPosition, data, pickAProgram } = props;

  return (
    <PickProgramSectionWrapper>
      <PickProgramSectionMobileRightLightEggBg src={rightLightEgg} />

      <PickProgramSectionTitle>{data?.title}</PickProgramSectionTitle>

      <PickProgramSectionContent>
        <PickProgramSectionProducts>
          {planPositions.map((pp) => (
            <ProgramV2
              key={stripePlans[pp].id}
              product={stripePlans[pp]}
              onClick={() => pickAProgram(pp, stripePlans[pp].id)}
              chosenPlanPosition={chosenPlanPosition ?? DEFAULT_PLAN_KEY}
            />
          ))}
        </PickProgramSectionProducts>
      </PickProgramSectionContent>
    </PickProgramSectionWrapper>
  );
};
